import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "@/router";
import User from "@/models/user";

import auth from "@/store/modules/auth";
import installation_forms from "@/store/modules/installation_forms";
import orders from "@/store/modules/orders";
import invoices from "@/store/modules/invoices";
import inquiries from "@/store/modules/inquiries";
import customers from "@/store/modules/customers";
import devices from "@/store/modules/devices";
import devicesold from "@/store/modules/devicesold";
import stats from "@/store/modules/stats";
import constants from "@/store/modules/constants";
import axios_mod from "@/store/modules/axios_mod";
import synatec_orders from "@/store/modules/synatec_orders";
import fieldtracker from "@/store/modules/fieldtracker";
import terminations from "@/store/modules/terminations";
import kill_list from "@/store/modules/kill_list";
import services from "@/store/modules/services";

import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  endOfYesterday,
  subDays,
  addDays,
  subMonths
} from "date-fns";

Vue.use(Vuex);


console.log("ENV");
console.log(process.env.VUE_APP_MODE);
console.log(process.env);

export default new Vuex.Store({
  state: {
    appMode: process.env.VUE_APP_MODE,
    apiUrls: {
      login: process.env.VUE_APP_API_LOGIN_URL,
      graphQl: process.env.VUE_APP_API_URL,
      web_app_graphql: process.env.VUE_APP_WEB_APP_API_V2_URL,
      web_app_url: process.env.VUE_APP_WEB_APP_URL,
      billing_backend: process.env.VUE_APP_BILLING_BACKEND_URL,
      fieldtracker: process.env.VUE_APP_FIELDTRACKER_API_URL
    },
    allScheduledInvoices: [],
    allScheduledInvoicesLoading: false,
    allInstallations: [],
    allInstallationsLoading: false,
    allServices: [],
    allServicesLoading: false,
    common: {
      locale: "nl"
    },
    fieldtracker_token: "",
    modals: {
      loading: false,
      system: false,
      systemRestriction: null,
      newCustomer: false,
      item: false
    },
    user: new User(),
    // If adding properties below, add them to "setNewInquiryClean" mutation also! TODO REFACTOR this sh*t!
    inquiry: {
      new: {
        customer: {
          customerId: 0,
          customerCountry: null,
          customerSet: false,
          notes: ""
        },
        company_id: null,
        startingDateSet: false,
        startingDate: null,
        retroactive_invoicing: false,
        currency: "EUR",
        agent: null
      }
    },
    contract_details_set: {
      contract_types: [],
      durations: [],
      termination_policies: []
    },
    customer_orders_items: []
  },
  getters: {
    getAppMode(state) {
      return state.appMode;
    },
    getLoginUrl(state) {
      return state.apiUrls.login;
    },
    getBackendUrl(state) {
      return state.apiUrls.billing_backend;
    },
    getWebAppUrl(state) {
      return state.apiUrls.web_app_url;
    },
    getFieldTrackerUrl(state) {
      return state.apiUrls.fieldtracker;
    },
    getLocale(state) {
      return state.common.locale;
    },
    getUserToken(state) {
      return state.user.token;
    },
    getUserName(state) {
      return state.user.name;
    },
    getUserSystem(state) {
      return state.user.system;
    },
    getCustomerNotes(state) {
      return state.inquiry.new.customer.notes;
    },
    getUserPermissions(state) {
      return state.user.permissions;
    },
    getUserBrandPermissions(state) {
      return state.user.brandPermissions;
    },
    getShowSystemModal(state) {
      return state.modals.system;
    },
    getSystemRestrictionBrand(state) {
      return state.modals.systemRestriction;
    },
    getShowNewCustomerModal(state) {
      return state.modals.newCustomer;
    },
    getShowItemModal(state) {
      return state.modals.item;
    },
    getShowLoadingModal(state) {
      return state.modals.loading;
    },
    getInquiryNew(state) {
      return state.inquiry.new;
    },
    getCurrency(state) {
      return state.inquiry.new.currency;
    },
    getAgent(state) {
      return state.inquiry.new.agent;
    },
    getCompany(state) {
      return state.inquiry.new.company_id;
    },
    getGraphQlUrl(state) {
      return state.apiUrls.graphQl;
    },
    getDefConf(state) {
      return {
        headers: {
          Authentication: `Token token=${state.user.token}`,
          brand: state.user.system.toLowerCase(),
          appMode: state.appMode
        }
      };
    },
    getWebAppGraphQlUrl(state) {
      return state.apiUrls.web_app_graphql;
    },
    getAllScheduledInvoices(state) {
      return state.allScheduledInvoices;
    },
    getAllScheduledInvoicesLoading(state) {
      return state.allScheduledInvoicesLoading;
    },
    getAllInstallations(state) {
      return state.allInstallations;
    },
    getAllInstallationsLoading(state) {
      return state.allInstallationsLoading;
    },
    getAllServices(state) {
      return state.allServices;
    },
    getAllServicesLoading(state) {
      return state.allServicesLoading;
    },
    getContractDetailsSet(state) {
      return state.contract_details_set;
    },
    getTodayRange() {
      let from = new Date();
      let to = addDays(from, 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getYesterdayRange() {
      let now = new Date();
      let from = endOfYesterday(now);
      let to = now;

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getThisWeekRange() {
      let now = new Date();
      let from = addDays(startOfWeek(now, { weekStartsOn: 0 }), 1);
      let to = addDays(endOfWeek(now, { weekStartsOn: 1 }), 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getLastWeekRange() {
      let now = subDays(new Date(), 7);
      let from = addDays(startOfWeek(now, { weekStartsOn: 0 }), 1);
      let to = addDays(endOfWeek(now, { weekStartsOn: 1 }), 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getThisMonthRange() {
      let now = new Date();
      let from = startOfMonth(now);
      let to = addDays(endOfMonth(now), 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getLastMonthRange() {
      let now = new Date();
      let from = subMonths(startOfMonth(now), 1);
      let to = subMonths(addDays(endOfMonth(now), 1), 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getThisYearRange() {
      let now = new Date();
      let from = new Date(now.getFullYear(), 0);
      let to = new Date(now.getFullYear() + 1, 0);

      from.setHours(from.getHours() + 1);
      to.setHours(to.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getTwoYearsAgoRange() {
      let now = new Date();
      let from = new Date(now.getFullYear() - 2, 0);
      let to = new Date(now.getFullYear() - 1, 0);

      from.setHours(from.getHours() + 1);
      to.setHours(to.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getLastYearRange() {
      let now = new Date();
      let from = new Date(now.getFullYear() - 1, 0);
      let to = new Date(now.getFullYear(), 0);

      from.setHours(from.getHours() + 1);
      to.setHours(to.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getNextYearRange() {
      let now = new Date();
      let from = new Date(now.getFullYear() + 1, 0);
      let to = new Date(now.getFullYear() + 2, 0);

      from.setHours(from.getHours() + 1);
      to.setHours(to.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getThisQuarterRange() {
      let now = new Date();
      let monthIndex = now.getMonth();
      let from;
      let to;

      if (monthIndex < 3) {
        from = new Date(now.getFullYear(), 0);
        to = new Date(now.getFullYear(), 3);
      } else if (monthIndex < 6) {
        from = new Date(now.getFullYear(), 3);
        to = new Date(now.getFullYear(), 6);
      } else if (monthIndex < 9) {
        from = new Date(now.getFullYear(), 6);
        to = new Date(now.getFullYear(), 9);
      } else {
        from = new Date(now.getFullYear(), 9);
        to = new Date(now.getFullYear() + 1, 0);
      }

      from.setHours(now.getHours() + 1);
      to.setHours(now.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getLastQuarterRange() {
      let now = new Date();
      let monthIndex = now.getMonth();
      let from;
      let to;

      if (monthIndex < 3) {
        from = new Date(now.getFullYear(), 0);
        to = new Date(now.getFullYear(), 3);
      } else if (monthIndex < 6) {
        from = new Date(now.getFullYear(), 3);
        to = new Date(now.getFullYear(), 6);
      } else if (monthIndex < 9) {
        from = new Date(now.getFullYear(), 6);
        to = new Date(now.getFullYear(), 9);
      } else {
        from = new Date(now.getFullYear(), 9);
        to = new Date(now.getFullYear() + 1, 0);
      }

      from.setMonth(from.getMonth() - 3);
      to.setMonth(to.getMonth() - 3);

      from.setHours(now.getHours() + 1);
      to.setHours(now.getHours() + 1);

      return [
        `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`,
        `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`
      ];
    },
    getCustomerOrdersItems(state) {
      return state.customer_orders_items;
    }
  },
  mutations: {
    setSystem(state, system) {
      for (let i = 0; i < state.user.permissions.length; i++) {
        if (state.user.permissions[i].brand === system.toLowerCase()) {
          state.user.brandPermissions = state.user.permissions[i];
        }
      }
      state.user.system = system;
      let user = JSON.parse(localStorage.getItem("user"));
      user = state.user;
      localStorage.setItem("user", JSON.stringify(user));
      state.allServices = [];
    },
    setUser(state, user) {
      state.user = user;
    },
    setShowSystemModal(state, value) {
      state.modals.system = value;
    },
    setSystemRestrictionBrand(state, brand) {
      state.modals.systemRestriction = brand;
    },
    setShowNewCustomerModal(state, value) {
      state.modals.newCustomer = value;
    },
    setShowItemModal(state, value) {
      state.modals.item = value;
    },
    setShowLoadingModal(state, value) {
      state.modals.loading = value;
    },
    setCustomerSet(state, value) {
      state.inquiry.new.customer.customerSet = value;
    },
    setNewInquiryCustomerNotes(state, value) {
      state.inquiry.new.customer.notes = value;
    },
    setNewInquiryCustomerId(state, value) {
      state.inquiry.new.customer.customerId = value;
    },
    setNewInquiryStartingDate(state, value) {
      state.inquiry.new.startingDate = value;
      state.inquiry.new.startingDateSet = true;
    },
    setNewInquiryRetroactiveInvoicing(state, value) {
      state.inquiry.new.retroactive_invoicing = value;
    },
    setLocale(state, value) {
      state.common.locale = value;
    },
    setNewInquiryClean(state) {
      state.inquiry.new = {
        customer: {
          customerId: 0,
          customerCountry: null,
          customerSet: false,
          notes: ""
        },
        startingDateSet: false,
        startingDate: null,
        retroactive_invoicing: false,
        currency: "EUR",
        agent: null,
        company_id: null
      };
    },
    setCurrency(state, value) {
      state.inquiry.new.currency = value;
    },
    setAgent(state, value) {
      state.inquiry.new.agent = value;
    },
    setCompany(state, value) {
      state.inquiry.new.company_id = value;
    },
    setNewInquiryCustomerCountry(state, value) {
      state.inquiry.new.customer.customerCountry = value;
    },
    setAllScheduledInvoices(state, scheduledInvoices) {
      state.allScheduledInvoices = scheduledInvoices;
    },
    setAllScheduledInvoicesLoading(state, loading) {
      state.allScheduledInvoicesLoading = loading;
    },
    setAllInstallations(state, installations) {
      state.allInstallations = installations;
    },
    setAllInstallationsLoading(state, loading) {
      state.allInstallationsLoading = loading;
    },
    setAllServices(state, value) {
      state.allServices = value;
    },
    setAllServicesLoading(state, loading) {
      state.allServicesLoading = loading;
    },
    setContractDetailsSets(state, payload) {
      state.contract_details_set = payload;
    },
    setCustomerOrdersItems(state, payload) {
      state.customer_orders_items = payload;
    }
  },
  actions: {
    changeSystem({ commit }, system) {
      commit("setSystem", system);
      router.push({ name: "dashboard" });
      commit("setShowSystemModal", false);
    },
    fetchAllScheduledInvoices({ commit }, payload) {
      commit("setAllScheduledInvoicesLoading", true);

      const data = {
        query: `
          query {
            allScheduledInvoices(days: ${payload.days}) {
              id
              schedule_at
              status
              total_price
              order {
                id
                currency
              }
            }
          }
        `
      };

      axios
        .post(this.getters.getGraphQlUrl, data, this.getters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            let scheduledInvoices = res.data.data.allScheduledInvoices.map(
              invoice => {
                return {
                  id: invoice.id,
                  schedule_at: invoice.schedule_at.substring(0, 10),
                  order_id: invoice.order.id,
                  currency: invoice.order.currency,
                  status: invoice.status,
                  total_price: invoice.total_price,
                  _rowVariant:
                    invoice.status == "scheduled"
                      ? "success"
                      : invoice.status == "scheduled_plus"
                        ? "info"
                        : "danger"
                };
              }
            );

            commit("setAllScheduledInvoices", scheduledInvoices);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          commit("setAllScheduledInvoicesLoading", false);
        });
    },
    fetchFleetImeisStatus(_, payload) {
      const imeis = (payload.imeis || []).map(imei => `"${imei}"`).join(", ");
      const data = {
        query: `
          query {
            DevicesByImeis (imeis: [${imeis}]) {
              imei
              owner {
                id
              }
            }
          }
        `
      };

      return axios
        .post(this.getters.getWebAppGraphQlUrl, data, {
          headers: { Authorization: `Token token=${this.getters.getUserToken}` }
        })
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
            return [];
          }
          return (res.data.data.DevicesByImeis || []).map(device => ({
            owner_id: device.owner != null ? device.owner.id : null,
            imei: device.imei
          }));
        })
        .catch(err => {
          alert(err);
          console.error(err);
          return [];
        });
    },
    fetchAllInstallations({ commit }) {
      commit("setAllInstallationsLoading", true);

      const data = {
        query: `
          query {
            allDeviceIntallations {
              id
              status
              connection_status 
              user {
                id
              }
              vehicle {
                id
              }
              imei
              installation_type
              notes
              created_at
              updated_at
            }
          }
        `
      };

      axios
        .post(this.getters.getWebAppGraphQlUrl, data, {
          headers: { Authorization: `Token token=${this.getters.getUserToken}` }
        })
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            commit("setAllInstallations", res.data.data.allDeviceIntallations);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          commit("setAllInstallationsLoading", false);
        });
    },
    fetchAllServices({ commit }) {
      commit("setAllServicesLoading", true);

      const data = {
        query: `
          query {
            allServices {
              id
              agent {
                full_name
              }
              order {
                id
                order_no
              }
              customer {
                id
                company_name
              }
              status
              installation_form_id
              needs_to_be_billed
              fieldtracker_reference
              fieldtracker_task_name
              warranty
              service_type
              created_at
              updated_at
              _rowVariant
            }
          }
        `
      };

      axios
        .post(this.getters.getGraphQlUrl, data, this.getters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            commit("setAllServices", res.data.data.allServices);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          commit("setAllServicesLoading", false);
        });
    },
    fetchSoldDevicesForRange({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              soldDevicesForRange(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchOrdersCreatedForRange({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              ordersCreatedForRange(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchSentInvoicesForRange({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              invoicesSentForRange(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchInquiriesCreatedForRange({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              inquiriesCreatedForRange(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchInquiryOrderRatio({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              inquiriesOrderRatio(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0] != null ? range[0] : ""}",
                date_to: "${range[1] != null ? range[1] : ""}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchOrderDurationAvg({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              avgContractLength(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoOrders({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noOrdersForStatus(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}",
                status: "${payload.status}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoInquiries({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noInquiriesForStatus(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}",
                status: "${payload.status}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchCustomersCreatedForRange({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noCustomersForRange (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchMetricsTimeSeries({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              metricsTimeSeries (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.date_from}",
                date_to: "${payload.date_to}",
                period: "${payload.period}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
              reject(new Error(res.data.errors[0].message));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchInquiriesSummary({ commit }) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              inquiriesSummary (
                brand: "${this.getters.getUserSystem.toLowerCase()}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
              reject(new Error(res.data.errors[0].message));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchOrdersSummary({ commit }) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              ordersSummary (
                brand: "${this.getters.getUserSystem.toLowerCase()}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
              reject(new Error(res.data.errors[0].message));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchDevicesSummary({ commit }) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              devicesSummary (
                brand: "${this.getters.getUserSystem.toLowerCase()}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
              reject(new Error(res.data.errors[0].message));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchInvoicesSummary({ commit }) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              invoicesSummary (
                brand: "${this.getters.getUserSystem.toLowerCase()}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
              reject(new Error(res.data.errors[0].message));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoDevices({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noDevicesForStatus (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}",
                status: "${payload.status}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoCanceledDevices({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              canceledDevices (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoTerminatedDevices({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              terminatedDevices (
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
              )
            }
          `
        };

        axios
          .post(this.getters.getGraphQlUrl, data, this.getters.getDefConf)
          .then(res => {
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoInvoices({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noInvoices (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchNoScheduledInvoices({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              noScheduledInvoices (
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                date_to: "${payload.range[1] != null ? payload.range[1] : ""}",
                status: "${payload.status}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    noSynatecOhraOrders({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
              query {
                ${payload.status == "fulfilled" ? "noSynatecOrdersFulfilled" : "noSynatecOrdersCreated"
            } (
                  brand: "national_netherlands",
                  date_from: "${payload.range[0] != null ? payload.range[0] : ""
            }",
                  date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
                ) {
                  name
                  count
                }
              }
            `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    noSynatecOhraOrdersByStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
              query {
                noSynatecOrdersByStatus (
                  brand: "national_netherlands",
                  date_from: "${payload.range[0] != null ? payload.range[0] : ""}",
                  date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
                )
              }
            `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchPastRevenue({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              pastRevenue(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        if (this.state.debug) {
          console.log(JSON.stringify(data));
        }

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },
    fetchFutureRevenue({ commit }, range) {
      return new Promise((resolve, reject) => {
        const data = {
          query: `
            query {
              futureRevenue(
                brand: "${this.getters.getUserSystem.toLowerCase()}",
                date_from: "${range[0]}",
                date_to: "${range[1]}"
              )
            }
          `
        };

        axios
          .post(this.state.apiUrls.graphQl, data, {
            headers: {
              Authentication: `Token token=${this.state.user.token}`
            }
          })
          .then(res => {
            if (this.state.debug) console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            }
            resolve(res);
          })
          .catch(err => {
            alert(err);
            reject(err);
            console.error(err);
          });
      });
    },

    fetchContracDetailsSets({ commit }) {
      const data = {
        query: `
          query {
            contract_details_set{
              contract_types
              durations
              termination_policies
              my_environment_exceptions
            }
          }
        `
      };

      axios
        .post(this.state.apiUrls.graphQl, data, {
          headers: {
            Authentication: `Token token=${this.state.user.token}`
          }
        })
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            commit(
              "setContractDetailsSets",
              res.data.data.contract_details_set
            );
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        });
    },
    fecthCustomerOrdersItems({ commit }, customer_id) {
      const data = {
        query: `query {
            Customer (id: ${customer_id}) {
              items{
                id
                order {
                  id
                  order_no
                  status
                  created_at
                }
                item_name
                price_per_month
                price_one_time
                discount
                item_type
                billing_item{
                  id
                }
              }
        }}
        `
      };
      axios
        .post(this.state.apiUrls.graphQl, data, {
          headers: {
            Authentication: `Token token=${this.state.user.token}`
          }
        })
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
            console.error(res.data.errors[0].message);
          } else {
            commit("setCustomerOrdersItems", res.data.data.Customer.items);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        });
    }
  },
  modules: {
    auth,
    installation_forms,
    orders,
    invoices,
    inquiries,
    customers,
    devices,
    devicesold,
    fieldtracker,
    stats,
    constants,
    axios_mod,
    synatec_orders,
    terminations,
    kill_list,
    services
  }
});
